/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { HIGHCHARTS_DEFAULT_OPTIONS } from '../../../../Chart.constants';
import { SankeyChartProps } from '../../SankeyChart.props';

/**
 * Parse SankeyChart props into a Highcharts format for the general options.
 */
export const getSankeyGeneralOptions = (props: SankeyChartProps): Highcharts.Options => {
  const { description, height, width, subtitle, title, tooltipContent, tooltipOptions } = { ...props };

  const options = { ...HIGHCHARTS_DEFAULT_OPTIONS };

  options.accessibility = {
    point: {
      valueDescriptionFormat: '{index}. {point.from} to {point.to}, {point.weight}.',
    },
  };
  options.chart = { height, width };
  options.subtitle = { text: subtitle };
  options.title = { text: title };

  if (description) {
    options.caption = {
      align: 'center',
      text: description,
    };
  }
  if (tooltipOptions) {
    options.tooltip = {
      ...options.tooltip,
      ...tooltipOptions,
    };
  }
  if (tooltipContent) {
    options.tooltip = {
      ...options.tooltip,
      formatter: function formatter(): string {
        return tooltipContent(this);
      },
      useHTML: true,
    };
  }

  return options;
};
